export enum UnitOfMeasure {
  UNKNOWN,
  USD_GALLON,
  CAD_LITER
}

export enum ReportFrequency {
  UNKNOWN = 'Unknown',
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  ANNUALLY = 'Annually'
}

export class TaxAccount {
  id: { value: string };
  accountNumber?: string;
  businessAccountId: { value: string };
  jurisdiction: string;
  companyName: string;
  preferred: boolean;
  federalTaxId: string;
  unitOfMeasure: UnitOfMeasure;
  usDotNumber: string;
  jurisdictionId: string;
  streetAddress: string;
  city: string;
  postalCode: string;
  filingJurisdiction: string;
  iftaEnabled: boolean;
  iftaFrequency: ReportFrequency;
  nyHutEnabled: boolean;
  nyHutFrequency: ReportFrequency;
  kyHutEnabled: boolean;
  kyHutFrequency: ReportFrequency;
  fuelEfficiencyMin: number;
  fuelEfficiencyMax: number;
  nyHutTaxPayerId: string;
  kyHutTaxPayerId: string;
  createdDate: string;
  modifiedDate: string;
  deletedDate: string;
  nmHutEnabled: boolean;
  nmHutFrequency: ReportFrequency;
  nmHutTaxPayerId: string;
  orHutEnabled: boolean;
  orHutFrequency: ReportFrequency;
  orHutTaxPayerId: string;
  ctHutEnabled: boolean;
  ctHutFrequency: ReportFrequency;
  ctHutTaxPayerId: string;
}

export class APITaxAccount extends TaxAccount {
  vehicleIDs: [];
}
